import { render, staticRenderFns } from "./ChangeKennelOwnerList.vue?vue&type=template&id=77eb3a17"
import script from "./ChangeKennelOwnerList.vue?vue&type=script&lang=ts"
export * from "./ChangeKennelOwnerList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports